import "./assets/main.css";
import { TimeoutError, HTTPError } from "ky";
import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";

import { defineRule, configure } from "vee-validate";
import { required, email, min } from "@vee-validate/rules";
import { localize, setLocale } from "@vee-validate/i18n";
import { Form } from "vee-validate";
import ru from "@vee-validate/i18n/dist/locale/ru.json";
// import eHundler from "./registr-error-handlers.js"

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount("#app");
app.component("Form", Form);

localize({ ru });
setLocale("ru");
defineRule("required", required);
defineRule("email", email);
defineRule("min", min);
configure({
  generateMessage: localize("ru", {
    names: {
      date: "дата",
      password: "пароль",
      email: "почта",
      name: "имя",
    },
  }),
});

// eHundler(app,router);
console.log("sss");

window.addEventListener("unhandledrejection", ({ reason: err }) => {
  errorHandler(err);
});

window.addEventListener("error", (errMessage) => {
  console.error("global", errMessage);
});

app.config.errorHandler = (err, vm, info) => {
  errorHandler(err);
};

async function errorHandler(err) {
  if (err instanceof TimeoutError) {
    return "reload";
  } else if (err instanceof HTTPError) {
    if (err.response.status === 401) {
      // cleanTokensData();
      router.push({ name: "auth" });
      // Notify.create({
      //   type: 'negative',
      //   message: 'Test 401',
      //   position: 'top',
      // });
      return;
    } else if (err.response.status === 403) {
      console.log(403);
      console.log(err.response);
      console.log(err.response.message);
      const message = (await err.response.json()).error;
      alert(message);

      // Notify.create({
      //   type: 'negative',
      //   message: 'Доступ запрещен',
      //   position: 'top',
      // });
      return;
    } else if (err.response.status === 404) {
      console.log(404);
      const message = (await err.response.json()).error;
      alert(message);
      // Notify.create({
      //   type: 'negative',
      //   message: 'Ресурс не найден',
      //   position: 'top',
      // });
      return;
    } else if (err.response.status === 429) {
      console.log(429);
      const message = (await err.response.json()).error;
      alert(message);
      // Notify.create({
      //   type: 'negative',
      //   message: 'Что-то пошло не так! Попробуйте позже.',
      //   position: 'top',
      // });
      return;
    }
    // Notify.create({
    //   type: 'negative',
    //   message: 'Ошибка сервера',
    //   position: 'top',
    // });
    console.log(500);

    return;
  } else {
    alert("Нет доступа к интернет");
  }

  // const message = (await err.response.json()).error;
  // alert(message);
}
